import { createFileRoute } from '@tanstack/react-router';
import { EditStoreAddress } from '@/features/business/components/edit/EditStoreAddress';

export const Route = createFileRoute('/(app)/(store)/store/edit/address')({
  component: RouteComponent,
});

function RouteComponent() {
  return <EditStoreAddress />;
}
